export const appSettings = {
    appTitle: 'Admin Toolkit',
    appLogo: 'https://www.google.com/a/cpanel/DOMAIN_NAME/images/logo.gif?service=google_gsuite',
    appSmallLogo: 'https://www.google.com/a/cpanel/DOMAIN_NAME/images/logo.gif?service=google_gsuite',
    //appLogo: '/assets/images/logo/logo.png',
    //appSmallLogo: '/assets/images/logo/small-logo.png',
    applicationTypes: ['Visa', 'Renewal', 'Permanent Residence', 'Others' ]
  };
